"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSSL001_Detail = void 0;
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../common");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const server_1 = require("../../../server");
const account_1 = require("../../base/account");
const layout_1 = require("../../base/layout");
const DSTL001_Detail_Child_1 = require("../../DST/DSTL001/component/DSTL001_Detail_Child");
const ScoreReportPdf_1 = require("../../DST/DSTL001/component/DSTL001_Detail_Child/ScoreReportPdf");
const ScoreReportViewer_1 = require("../../DST/DSTL001/component/DSTL001_Detail_Child/ScoreReportViewer");
const TaskInfoTeacherContainer_1 = require("../../DST/DSTL001/component/DSTL001_Detail_Child/TaskInfoTeacherContainer");
const constant_1 = require("../../DST/DSTL001/constant");
const function_1 = require("../../DST/DSTL001/function");
const action_1 = require("../../menu/action");
const DSSL001_Detail_Child_1 = require("./DSSL001_Detail_Child");
const SubmissionPopup_1 = require("./DSSL001_Detail_Child/SubmissionPopup");
const DSSL001DetailStyled = styled_components_1.default.div `
	.task-isMobile {
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	/* p.29: 상단 고정 기본정보 영역 여백 */
	.mobile-fixed-info {
		width: 100%;
		box-sizing: border-box;
		padding: 16px 18px;
	}

	/* p.41-1: 문항/제출버튼 좌우 여백 추가 (응시 전 문항 풀이 영역) */
	.mobile-question-detail {
		width: 100%;
		box-sizing: border-box;
		padding: 0 18px 20px;
	}

	/* p.41-2: 상단 고정 기본정보 — 비활성 입력란 대신 간략 텍스트 레이아웃 */
	.task-info-compact {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	.task-info-compact .compact-row {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		gap: 10px;
	}
	.task-info-compact .compact-label {
		flex-shrink: 0;
		min-width: 56px;
		color: var(--color-grey-d, #6b7079);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 13px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 600;
	}
	.task-info-compact .compact-value {
		color: var(--color-black, #101010);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 13px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 400;
		word-break: break-all;
	}
	/* 첨부 파일명: 텍스트로 표기, 클릭 시 다운로드 */
	.task-info-compact .compact-attach-file {
		color: var(--color-tur, #3ab2bf);
		text-decoration: underline;
		cursor: pointer;
		word-break: break-all;
	}

	.placeholder_wrap {
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 12px 10px 12px 10px;
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		p {
			white-space: break-spaces;
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			align-self: stretch;
			flex: 1;
			word-break: break-all;
		}
	}
	&.dss001_detail {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		${props => props.$scoreReport ? `
			position: absolute;
			${props.$isDesktop ? `
			` : `
				padding: 15px;
			`}
		` : `
		`}
	}

	.task-info-wrap {
		display: flex;
		flex-direction: column;
		gap: 12px;
		width: 100%;
	}

	input:disabled,
	textarea:disabled {
		background: var(--color-white, #ffffff);
	}

	.warp-001 {
		display: flex;
		flex-direction: column;
		gap: ${({ $isMobile }) => ($isMobile ? '20px' : '30px')};
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		${props => props.$isTablet &&
    `
			width: 100%;
			height: 100%;
			padding: 20px;
		`}
	}
	.sub-info {
		border-style: dashed;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: ${({ $isMobile }) => ($isMobile ? '0' : ' 0px 0px 1px 0px;')};
		/* p.58: 테스트 기본정보 상단 여백이 사라져 제목과 붙어 보이던 문제 — 상단 padding을 하단과 동일하게 맞춤 */
		padding: ${({ $isMobile }) => ($isMobile ? '20px 0px 20px 0px;' : '28px 0px 28px 0px')};
		display: flex;
		flex-direction: row;
		gap: 8px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		flex-wrap: wrap;
	}

	.frame-987345 {
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		padding-bottom: 16px;
		${props => props.$isMobile && `height: min-content;`}
		${props => props.$isTablet && `min-height: 100%;`}
	}

	.wrong-rate-list {
		display: flex;
		flex-direction: column;
		gap: 10px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		// height: 100%;
		${({ $isTablet }) => $isTablet &&
    `
		min-height: 100%;
		`}
	}
	${({ $isTablet }) => $isTablet &&
    `
		.empty_data {
			flex: 1;
		}
	`}

	.title {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);

		letter-spacing: var(--h4-letter-spacing, -0.02em);
		font-weight: var(--h4-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		${({ $isMobile, $isTablet }) => $isMobile
    ? `
		font-size: var(--h6-font-size, 14px);
		line-height: var(--h6-line-height, 18px);
		`
    : $isTablet
        ? `
			font-size: var(--h5-font-size, 16px);
			line-height: var(--h5-line-height, 24px);`
        : `

			font-size: var(--h4-font-size, 20px);
			line-height: var(--h4-line-height, 32px);
		`}
	}

	.test-date-container {
		display: flex;
		flex-direction: column;
		gap: 12px;
		width: 100%;
	}

	.score-report-header {
		width: 100%;
		flex-shrink: 0;
	}

	.score-report-viewer-wrap {
		flex: 1;
		min-height: 0;
		overflow: hidden;
		position: relative;
		width: 100%;
	}

`;
exports.DSSL001_Detail = react_1.default.memo(({ isTest = false, test_id, props, isSurvey = false, }) => {
    const { isDesktop, isTablet, isMobile, classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const member_id = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const [isSubmit, setIsSubmit] = react_1.default.useState(false);
    const [item, setItem] = react_1.default.useState(null);
    const [isClosed, setIsClosed] = react_1.default.useState(false);
    const [selectedTestId, setSelectedTestId] = react_1.default.useState(test_id);
    const [pdfData, setPdfData] = react_1.default.useState(null);
    const [pdfLoading, setPdfLoading] = react_1.default.useState(false);
    const [pdfError, setPdfError] = react_1.default.useState('');
    const [pdfPayload, setPdfPayload] = react_1.default.useState(null);
    const { data, refetch } = (0, server_1.useAssignmentList)({
        id: test_id,
        class_id: classesId,
        survey: isSurvey,
    });
    const { data: classTestsData, refetch: refetchClassTests } = (0, server_1.useAssignmentList)({
        class_id: classesId,
        has_report: true,
    });
    const { data: answerData, refetch: answerRefetch } = (0, server_1.useAnswerList)({
        test_id,
        from: member_id,
        orderby: 'value',
    });
    const refetchList = (0, lodash_1.throttle)(answerRefetch, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('ANSWER_REFETCH', refetchList);
        return () => {
            APP.eventManager.unsubscribe('ANSWER_REFETCH', refetchList);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (item && !isDesktop) {
            const omrTest = item.assignment === false && (item.type === 'OMR (기본형)' || item.type === 'OMR (자유형)');
            dispatch((0, action_1.changeMobileMenuName)(omrTest ? '테스트 상세보기' : item.title));
        }
    }, [item, isDesktop, isTablet, isMobile]);
    (0, react_1.useEffect)(() => {
        refetch();
    }, [test_id]);
    (0, react_1.useEffect)(() => {
        refetchList();
    }, [member_id, test_id]);
    (0, react_1.useEffect)(() => {
        if (!data)
            return;
        if (data.found_count > 0) {
            const item = data.items[0];
            // 목록(AssignmentTableStudents)과 동일 기준으로 종료 판정 통일:
            // 서버 status=closed 뿐 아니라 deadline 경과(open→시각 재계산)도 종료로 인정.
            // calculateActualStatus 는 closed/특수상태 보존, created/open 만 시각 재계산.
            const closed = (0, function_1.calculateActualStatus)(item) === constant_1.TEST_STATUS.CLOSED;
            setIsClosed(closed);
            setItem(item);
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (!answerData)
            return;
        if (answerData.found_count > 0) {
            setIsSubmit(true);
        }
        else {
            setIsSubmit(false);
        }
    }, [answerData]);
    const previousPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: undefined,
            id: undefined,
        });
    };
    const renderTaskInfo = (0, react_1.useMemo)(() => isMobile || isTablet ? (react_1.default.createElement("div", { key: "task-info", className: "task-isMobile" },
        react_1.default.createElement(TaskInfoTeacherContainer_1.TaskInfoTeacherContainer, { isTest: isTest, item: item, isSurvey: isSurvey }))) : (react_1.default.createElement(DSTL001_Detail_Child_1.TaskInfoContainer, { key: "task-info", isTest: isTest, item: item, isSubmit: isSubmit, isSurvey: isSurvey })), 
    // isTablet 누락 시: 데스크탑→태블릿 리사이즈/방향전환에서 memo가 갱신되지 않아
    // 태블릿 '기본 정보' 탭에 데스크탑용 TaskInfoContainer가 그대로 남던 문제 → isTablet 추가
    [item, isMobile, isTablet, isTest, isSubmit, isSurvey]);
    const renderSubmissionStatusTable = (0, react_1.useMemo)(() => (react_1.default.createElement(SubmissionPopup_1.SubmissionPopup, { key: "submission-info", test_id: test_id, member_id: member_id, item: item, props: {
            isTest,
            subject_name: item?.subject,
            isDetail: true,
            test_id,
            member_id,
            isTeacher,
            isSurvey,
        } })), [item, isTest, test_id, member_id, isTeacher, isSurvey]);
    const renderSubmissionGraph = (0, react_1.useMemo)(() => (react_1.default.createElement(DSSL001_Detail_Child_1.SubmitResult, { key: "submission-info", isSubmit: isSubmit, test_id: test_id, member_id: member_id })), [isSubmit, test_id, member_id]);
    const renderErrorContainer = (0, react_1.useMemo)(() => (react_1.default.createElement(DSSL001_Detail_Child_1.ErrorContainer, { key: "error-info", item: item, isTest: isTest, isSubmit: isSubmit, test_id: test_id })), [item, isTest, isSubmit, test_id]);
    // 설문형: 정답/점수 개념이 없어 SubmitResult 전체(점수 UI/제출결과 탭)는 제외하되,
    // 제출 완료 시 '제출이 완료되었습니다' 메시지만 기본정보 영역에 노출 (messageOnly 모드)
    const renderSurveySubmitMessage = (0, react_1.useMemo)(() => (react_1.default.createElement(DSSL001_Detail_Child_1.SubmitResult, { key: "survey-submit-message", isSubmit: isSubmit, test_id: test_id, member_id: member_id, messageOnly: true })), [isSubmit, test_id, member_id]);
    // p.43: 테스트 기간 중이라도 응시 완료(isSubmit) 시 제출결과(점수) 즉시 노출
    const shouldShowSubmitResult = item?.type !== '설문형' && (isClosed || isSubmit);
    // 설문형 전용: 제출 완료 시 메시지(제출이 완료되었습니다)만 기본정보 영역에 노출
    const shouldShowSurveySubmitMessage = item?.type === '설문형' && isSubmit;
    const shouldShowErrorContainer = isClosed && !isSurvey;
    const isOmrType = item?.type === 'OMR (기본형)' || item?.type === 'OMR (자유형)';
    // 73p: 성적표 vs 정오표 게이트. 성적 데이터 등록 여부는 /tests 의 has_report 로 판단(서버 확정).
    //  - 강대K/이감(grade_report=true): has_report=true 면 진행중에도 성적표.
    //  - 기타(grade_report=false): 응시 기간(마감일시) 종료 후에만 성적표(isTestPeriodEnded).
    //    ※ 강의실 강제종료(status=closed)로는 노출 안 함 — 응시 기간이 실제로 끝나야 일괄 노출.
    // has_report=true(데이터 존재) 또는 응시 기간 종료일 때만 켜므로 "불러오지 못했습니다" 회귀 없음. isOmrType 필터로 타 유형 불변.
    const showScoreReportLayout = isTest && isOmrType && !!item && (item.grade_report ? !!item.has_report : (0, function_1.isTestPeriodEnded)(item));
    const reportTestList = (0, react_1.useMemo)(() => {
        if (!classTestsData?.items)
            return [];
        return classTestsData.items
            .filter(t => t.type === 'OMR (기본형)' || t.type === 'OMR (자유형)')
            .sort((a, b) => new Date(b.creation_time).getTime() - new Date(a.creation_time).getTime())
            .map(t => ({ id: t.id, title: t.title }));
    }, [classTestsData]);
    const selectedDropdownItem = (0, react_1.useMemo)(() => reportTestList.find(t => t.id === selectedTestId) ?? { id: selectedTestId, title: item?.title ?? '' }, [reportTestList, selectedTestId, item]);
    (0, react_1.useEffect)(() => {
        refetchClassTests();
    }, [classesId]);
    (0, react_1.useEffect)(() => {
        setSelectedTestId(test_id);
    }, [test_id]);
    (0, react_1.useEffect)(() => {
        if (!showScoreReportLayout || !selectedTestId || !member_id)
            return;
        let cancelled = false;
        setPdfLoading(true);
        setPdfData(null);
        setPdfError('');
        setPdfPayload(null);
        const selectedItem = classTestsData?.items?.find(t => t.id === selectedTestId);
        const reportType = selectedItem?.report_type ?? item?.report_type ?? '';
        Promise.all([
            (0, server_1.getReportData)({ id: selectedTestId, queryString: `member_id=${encodeURIComponent(member_id)}` }),
            (0, server_1.getTierCutoff)(selectedTestId, member_id),
            // ref_test_id: 선택된 테스트와 같은 성적표(상세) 유형의 회차만 조회 — 기타(etc)에서 상세유형(홍모/K+ 등)이 섞이지 않도록.
            (0, server_1.getGradeReport)({ id: member_id, queryString: `class_id=${encodeURIComponent(classesId)}&report_type=${encodeURIComponent(reportType)}&ref_test_id=${encodeURIComponent(selectedTestId)}` }),
        ])
            .then(([reportRes, cutoffRes, gradeRes]) => {
            if (cancelled)
                return;
            // 같은 회차 재응시는 'N회차(재)' — ref_test_id 조회 결과 + 안정 정렬(같은 회차는 서버 순서=시간 순 유지) 전제
            const sortedGradeReport = (0, server_1.markRetakeRounds)((gradeRes.result?.items ?? [])
                .slice()
                .sort((a, b) => (a.round ?? 0) - (b.round ?? 0)));
            const payload = {
                report: reportRes.result,
                tierCutoffs: cutoffRes.result?.items ?? [],
                gradeReport: sortedGradeReport,
                subjectLabel: selectedItem?.subject ?? item?.subject,
                testDate: selectedItem?.deadline ?? item?.deadline,
                reportType,
                showGradeReport: !!(selectedItem?.grade_report ?? item?.grade_report),
                reportName: selectedItem?.report_name ?? item?.report_name,
            };
            return (0, ScoreReportPdf_1.openScoreReportPdf)(payload).then(pdf => {
                if (cancelled)
                    return;
                setPdfPayload(payload);
                setPdfData(pdf);
            });
        })
            .catch(err => {
            if (!cancelled)
                setPdfError(err?.message || '성적표를 불러오지 못했습니다.');
        })
            .finally(() => {
            if (!cancelled)
                setPdfLoading(false);
        });
        return () => {
            cancelled = true;
        };
    }, [showScoreReportLayout, selectedTestId, member_id, classesId]);
    const handleDownloadPdf = async () => {
        if (!pdfPayload)
            return;
        const filename = `${selectedDropdownItem.title || 'score-report'}.pdf`;
        await (0, ScoreReportPdf_1.downloadScoreReportPdf)(pdfPayload, filename);
    };
    const renderTestDropdown = (react_1.default.createElement(common_1.DropDown, { className: "dropdown-small", value: selectedDropdownItem, list: reportTestList, setDropValue: (v) => setSelectedTestId(v.id), styles: { dropWrap: { minWidth: 240 }, itemWrap: { maxHeight: 300, overflowY: 'auto' } } }));
    const renderScoreReportViewer = (react_1.default.createElement("div", { className: "score-report-viewer-wrap" },
        react_1.default.createElement(ScoreReportViewer_1.ScoreReportViewer, { pdfData: pdfData, filename: `${selectedDropdownItem.title || 'score-report'}.pdf`, title: selectedDropdownItem.title, onDownload: handleDownloadPdf, isStudent: true, externalLoading: pdfLoading, externalError: pdfError })));
    if (!item)
        return null;
    if (showScoreReportLayout) {
        if (!isDesktop) {
            return (react_1.default.createElement(DSSL001DetailStyled, { className: "dss001_detail", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile, "$scoreReport": true },
                react_1.default.createElement("div", { className: "score-report-header" }, renderTestDropdown),
                renderScoreReportViewer));
        }
        return (react_1.default.createElement(DSSL001DetailStyled, { className: "dss001_detail wrapper-padding", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile, "$scoreReport": true },
            react_1.default.createElement(DSTL001_Detail_Child_1.InfoTitle, { isTeacher: false, title: item.title, test_id: test_id, isTest: isTest, previousPage: previousPage, testSelector: renderTestDropdown, hideTitle: true }),
            renderScoreReportViewer));
    }
    // 모바일/태블릿(가로·세로 모두) 동일 구조:
    // 상단에 기본정보 고정 + 그 아래 결과 탭(있으면)/문항별 상세(없으면 직접)
    // — 태블릿 전용 '기본 정보' 탭은 제거(모바일과 동일)
    if (isMobile || isTablet) {
        // p.29: 기본정보 영역 상단 고정(테스트/과제명 제외) + 기존 '기본정보' 탭 삭제
        const fixedBaseInfo = (react_1.default.createElement("div", { key: "fixed-base-info", className: "task-isMobile mobile-fixed-info" },
            react_1.default.createElement(TaskInfoTeacherContainer_1.TaskInfoTeacherContainer, { isTest: isTest, item: item, isSurvey: isSurvey, hideName: true, compact: true }),
            shouldShowSurveySubmitMessage && renderSurveySubmitMessage));
        // 응시 후(제출결과/오답률 등 결과 데이터 존재)면 탭 노출, 응시 전이면 문항별 상세 바로
        const showResultTabs = shouldShowSubmitResult || shouldShowErrorContainer;
        return (react_1.default.createElement(DSSL001DetailStyled, { className: "dss001_detail", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile },
            fixedBaseInfo,
            showResultTabs ? (react_1.default.createElement(layout_1.MobileTabLayout, { isTabMode: true, tabList: [
                    ...(shouldShowSubmitResult
                        ? [
                            {
                                id: 2,
                                title: '제출결과',
                                component: [renderSubmissionGraph],
                                styles: {
                                    paddingBottom: '20px',
                                    paddingLeft: '18px',
                                    paddingRight: '18px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '24px',
                                },
                            },
                        ]
                        : []),
                    {
                        id: 3,
                        title: '문항별 상세',
                        component: [renderSubmissionStatusTable],
                        // p.41-1: 문항 좌우 여백
                        styles: {
                            paddingLeft: '18px',
                            paddingRight: '18px',
                        },
                    },
                    ...(shouldShowErrorContainer
                        ? [
                            {
                                id: 4,
                                title: '오답률',
                                component: renderErrorContainer,
                                styles: {
                                    height: '100%',
                                },
                            },
                        ]
                        : []),
                ], showNav: false, showPageButton: false, showPageTab: true, submitAssignment: previousPage, mobilePage: props?.mobilePage || undefined })) : (
            // 응시 전: 별도 탭 없이 문항별 상세(답안 입력) 바로 노출
            react_1.default.createElement("div", { className: "mobile-question-detail" }, renderSubmissionStatusTable))));
    }
    return (react_1.default.createElement(DSSL001DetailStyled, { className: "dss001_detail wrapper-padding", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile },
        isDesktop && (react_1.default.createElement(DSTL001_Detail_Child_1.InfoTitle, { isTeacher: false, title: item.title, test_id: test_id, isTest: isTest, previousPage: previousPage })),
        react_1.default.createElement("div", { className: "warp-001" },
            renderTaskInfo,
            shouldShowSubmitResult && (react_1.default.createElement(DSSL001_Detail_Child_1.SubmitResult, { isSubmit: isSubmit, test_id: test_id, member_id: member_id })),
            shouldShowSurveySubmitMessage && renderSurveySubmitMessage,
            react_1.default.createElement(SubmissionPopup_1.SubmissionPopup, { test_id: test_id, member_id: member_id, item: item, props: {
                    isTest,
                    subject_name: item?.subject,
                    isDetail: true,
                    test_id,
                    member_id,
                    isTeacher,
                    isSurvey,
                }, isClosed: isClosed }),
            shouldShowErrorContainer && (react_1.default.createElement(DSSL001_Detail_Child_1.ErrorContainer, { item: item, isTest: isTest, isSubmit: isSubmit, test_id: test_id })))));
});
